// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   CohortManager — ceremony cohorts within a retreat block
═══════════════════════════════════════════════════════════ */

.cm { display: flex; flex-direction: column; gap: 1rem; }

.cm__loading { display: flex; justify-content: center; padding: 2.5rem; }

/* ── Header ── */
.cm__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}
.cm__head-left { flex: 1 1; min-width: 0; }
.cm__head-icon { vertical-align: -3px; margin-right: 0.35rem; color: var(--admin-rust); }
.cm__head-sub {
  font-size: 0.8rem;
  color: var(--admin-muted);
  margin: 0.25rem 0 0;
  line-height: 1.5;
}
.cm__head-actions { display: flex; gap: 0.5rem; flex-wrap: wrap; }

/* ── Summary strip ── */
.cm__summary {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}
.cm__summary-item {
  flex: 1 1;
  min-width: 100px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.cm__summary-item--alert {
  background: rgba(217, 119, 6, 0.07);
  border-color: rgba(217, 119, 6, 0.3);
}
.cm__summary-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--admin-text);
  line-height: 1;
}
.cm__summary-of { font-size: 0.9rem; font-weight: 600; color: var(--admin-muted); }
.cm__summary-label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--admin-muted);
}

/* ── Empty state ── */
.cm__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.4rem;
  padding: 2.5rem 1.5rem;
  background: var(--admin-surface);
  border: 1px dashed var(--admin-border);
  border-radius: 10px;
}
.cm__empty-icon { font-size: 2rem; color: var(--admin-border); }
.cm__empty-title { font-size: 0.95rem; font-weight: 700; color: var(--admin-text); margin: 0; }
.cm__empty-sub {
  font-size: 0.82rem;
  color: var(--admin-muted);
  margin: 0 0 0.75rem;
  max-width: 340px;
  line-height: 1.55;
}

/* ── Cohort grid ── */
.cm__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 0.9rem;
  align-items: start;
}

.cm__card {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.cm__card--over { border-color: rgba(220, 38, 38, 0.4); }

.cm__card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}
.cm__card-name { font-size: 0.92rem; font-weight: 700; color: var(--admin-text); margin: 0; }
.cm__card-count {
  font-size: 0.76rem;
  color: var(--admin-muted);
  margin: 0.15rem 0 0;
  font-weight: 600;
}
.cm__card-count--full { color: var(--admin-green); }
.cm__card-count--over { color: var(--admin-red); }
.cm__card-actions { display: flex; gap: 0.15rem; flex-shrink: 0; }

/* ── Capacity bar ── */
.cm__bar {
  height: 5px;
  background: var(--admin-border);
  border-radius: 99px;
  overflow: hidden;
}
.cm__bar-fill {
  height: 100%;
  background: var(--admin-rust);
  border-radius: 99px;
  transition: width 0.25s ease;
}
.cm__bar-fill--full { background: var(--admin-green); }
.cm__bar-fill--over { background: var(--admin-red); }

.cm__card-notes {
  font-size: 0.76rem;
  color: var(--admin-muted);
  margin: 0;
  font-style: italic;
  line-height: 1.5;
}

/* ── Member rows ── */
.cm__members { display: flex; flex-direction: column; }
.cm__members-empty {
  font-size: 0.78rem;
  color: var(--admin-muted);
  text-align: center;
  padding: 0.85rem 0;
  margin: 0;
}

.cm__person {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0ebe4;
}
.cm__person:last-child { border-bottom: none; }
.cm__person-info { flex: 1 1; min-width: 0; }
.cm__person-name {
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.cm__checked-in { color: var(--admin-green); font-size: 0.85rem; display: inline-flex; }
.cm__person-meta {
  font-size: 0.71rem;
  color: var(--admin-muted);
  margin: 0.1rem 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm__person-action { position: relative; flex-shrink: 0; }
.cm__move-btn {
  font-size: 0.72rem !important;
  padding: 0.25rem 0.5rem !important;
  gap: 0.2rem;
}

/* ── Move dropdown ── */
.cm__move-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 120;
  min-width: 190px;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  padding: 0.35rem;
}
.cm__move-menu-title {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--admin-muted);
  margin: 0.2rem 0.5rem 0.35rem;
}
.cm__move-option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.5rem;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.79rem;
  color: var(--admin-text);
  text-align: left;
  transition: background 0.12s;
}
.cm__move-option:hover:not(:disabled) { background: var(--admin-surface); }
.cm__move-option:disabled { opacity: 0.45; cursor: not-allowed; }
.cm__move-option-count { font-size: 0.7rem; color: var(--admin-muted); flex-shrink: 0; }
.cm__move-option-count--full { color: var(--admin-red); }
.cm__move-option--unassign {
  color: var(--admin-red);
  border-top: 1px solid var(--admin-border);
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  border-radius: 0 0 6px 6px;
}
.cm__move-empty {
  font-size: 0.76rem;
  color: var(--admin-muted);
  padding: 0.5rem;
  margin: 0;
  text-align: center;
}

/* ── Unassigned pool ── */
.cm__unassigned {
  background: rgba(217, 119, 6, 0.05);
  border: 1px solid rgba(217, 119, 6, 0.28);
  border-radius: 10px;
  padding: 1rem;
}
.cm__unassigned-head { margin-bottom: 0.5rem; }
.cm__unassigned-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.86rem;
  font-weight: 700;
  color: #b45309;
  margin: 0;
}
.cm__unassigned-icon { font-size: 1rem; flex-shrink: 0; }
.cm__unassigned-sub {
  font-size: 0.77rem;
  color: var(--admin-muted);
  margin: 0.25rem 0 0;
  line-height: 1.5;
}

/* ── Modal fields ── */
.cm__field { display: flex; flex-direction: column; gap: 0.3rem; margin-bottom: 0.85rem; }
.cm__field label { font-size: 0.78rem; font-weight: 700; color: var(--admin-text); }
.cm__optional { font-weight: 400; color: var(--admin-muted); }
.cm__field-hint { font-size: 0.72rem; color: var(--admin-muted); margin: 0.1rem 0 0; line-height: 1.45; }

.cm__warn {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  font-size: 0.76rem;
  color: #b45309;
  background: rgba(217, 119, 6, 0.08);
  border: 1px solid rgba(217, 119, 6, 0.25);
  border-radius: 7px;
  padding: 0.6rem 0.7rem;
  margin-bottom: 0.85rem;
  line-height: 1.5;
}
.cm__warn svg { flex-shrink: 0; margin-top: 0.1rem; }

.cm__error {
  font-size: 0.79rem;
  font-weight: 600;
  color: var(--admin-red);
  margin: 0 0 0.75rem;
}

.cm__modal-actions { display: flex; gap: 0.5rem; justify-content: flex-end; }

/* ── Responsive ── */
@media (max-width: 767px) {
  .cm__head { flex-direction: column; }
  .cm__head-actions { width: 100%; }
  .cm__head-actions .a-btn { flex: 1 1; justify-content: center; }
  .cm__grid { grid-template-columns: 1fr; }
  .cm__summary-item { min-width: 0; }
  .cm__move-menu { right: auto; left: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/admin/CohortManager.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D,MAAM,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAExD,eAAe,aAAa,EAAE,uBAAuB,EAAE,eAAe,EAAE;;AAExE,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC,iBAAiB,oBAAoB,EAAE,qBAAqB,EAAE,wBAAwB,EAAE;AACxF;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,oBAAoB,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEjE,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;AACA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAClF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;AACrB;AACA,kBAAkB,eAAe,EAAE,0BAA0B,EAAE;AAC/D,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,SAAS,EAAE;AAC9F;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,kBAAkB,oCAAoC,EAAE;;AAExD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,SAAS,EAAE;AAC5F;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,wBAAwB,yBAAyB,EAAE;AACnD,wBAAwB,uBAAuB,EAAE;AACjD,oBAAoB,aAAa,EAAE,YAAY,EAAE,cAAc,EAAE;;AAEjE,uBAAuB;AACvB;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,sBAAsB,8BAA8B,EAAE;AACtD,sBAAsB,4BAA4B,EAAE;;AAEpD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB,eAAe,aAAa,EAAE,sBAAsB,EAAE;AACtD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,gCAAgC;AAClC;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA,kBAAkB,yBAAyB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AACvF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB,kBAAkB,EAAE,cAAc,EAAE;AACzD;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,wCAAwC,gCAAgC,EAAE;AAC1E,4BAA4B,aAAa,EAAE,mBAAmB,EAAE;AAChE,yBAAyB,iBAAiB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACvF,+BAA+B,uBAAuB,EAAE;AACxD;EACE,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;AACA,uBAAuB,qBAAqB,EAAE;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,uBAAuB,eAAe,EAAE,cAAc,EAAE;AACxD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB,aAAa,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,sBAAsB,EAAE;AACzF,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACnF,gBAAgB,gBAAgB,EAAE,yBAAyB,EAAE;AAC7D,kBAAkB,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAExG;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;AACA,gBAAgB,cAAc,EAAE,kBAAkB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB,aAAa,EAAE,WAAW,EAAE,yBAAyB,EAAE;;AAE5E,qBAAqB;AACrB;EACE,YAAY,sBAAsB,EAAE;EACpC,oBAAoB,WAAW,EAAE;EACjC,2BAA2B,SAAO,EAAE,uBAAuB,EAAE;EAC7D,YAAY,0BAA0B,EAAE;EACxC,oBAAoB,YAAY,EAAE;EAClC,iBAAiB,WAAW,EAAE,OAAO,EAAE;AACzC","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   CohortManager — ceremony cohorts within a retreat block\n═══════════════════════════════════════════════════════════ */\n\n.cm { display: flex; flex-direction: column; gap: 1rem; }\n\n.cm__loading { display: flex; justify-content: center; padding: 2.5rem; }\n\n/* ── Header ── */\n.cm__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n.cm__head-left { flex: 1; min-width: 0; }\n.cm__head-icon { vertical-align: -3px; margin-right: 0.35rem; color: var(--admin-rust); }\n.cm__head-sub {\n  font-size: 0.8rem;\n  color: var(--admin-muted);\n  margin: 0.25rem 0 0;\n  line-height: 1.5;\n}\n.cm__head-actions { display: flex; gap: 0.5rem; flex-wrap: wrap; }\n\n/* ── Summary strip ── */\n.cm__summary {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n.cm__summary-item {\n  flex: 1;\n  min-width: 100px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  padding: 0.7rem 0.9rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n.cm__summary-item--alert {\n  background: rgba(217, 119, 6, 0.07);\n  border-color: rgba(217, 119, 6, 0.3);\n}\n.cm__summary-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  line-height: 1;\n}\n.cm__summary-of { font-size: 0.9rem; font-weight: 600; color: var(--admin-muted); }\n.cm__summary-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n}\n\n/* ── Empty state ── */\n.cm__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.4rem;\n  padding: 2.5rem 1.5rem;\n  background: var(--admin-surface);\n  border: 1px dashed var(--admin-border);\n  border-radius: 10px;\n}\n.cm__empty-icon { font-size: 2rem; color: var(--admin-border); }\n.cm__empty-title { font-size: 0.95rem; font-weight: 700; color: var(--admin-text); margin: 0; }\n.cm__empty-sub {\n  font-size: 0.82rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.75rem;\n  max-width: 340px;\n  line-height: 1.55;\n}\n\n/* ── Cohort grid ── */\n.cm__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));\n  gap: 0.9rem;\n  align-items: start;\n}\n\n.cm__card {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n.cm__card--over { border-color: rgba(220, 38, 38, 0.4); }\n\n.cm__card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n.cm__card-name { font-size: 0.92rem; font-weight: 700; color: var(--admin-text); margin: 0; }\n.cm__card-count {\n  font-size: 0.76rem;\n  color: var(--admin-muted);\n  margin: 0.15rem 0 0;\n  font-weight: 600;\n}\n.cm__card-count--full { color: var(--admin-green); }\n.cm__card-count--over { color: var(--admin-red); }\n.cm__card-actions { display: flex; gap: 0.15rem; flex-shrink: 0; }\n\n/* ── Capacity bar ── */\n.cm__bar {\n  height: 5px;\n  background: var(--admin-border);\n  border-radius: 99px;\n  overflow: hidden;\n}\n.cm__bar-fill {\n  height: 100%;\n  background: var(--admin-rust);\n  border-radius: 99px;\n  transition: width 0.25s ease;\n}\n.cm__bar-fill--full { background: var(--admin-green); }\n.cm__bar-fill--over { background: var(--admin-red); }\n\n.cm__card-notes {\n  font-size: 0.76rem;\n  color: var(--admin-muted);\n  margin: 0;\n  font-style: italic;\n  line-height: 1.5;\n}\n\n/* ── Member rows ── */\n.cm__members { display: flex; flex-direction: column; }\n.cm__members-empty {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  text-align: center;\n  padding: 0.85rem 0;\n  margin: 0;\n}\n\n.cm__person {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f0ebe4;\n}\n.cm__person:last-child { border-bottom: none; }\n.cm__person-info { flex: 1; min-width: 0; }\n.cm__person-name {\n  font-size: 0.83rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n.cm__checked-in { color: var(--admin-green); font-size: 0.85rem; display: inline-flex; }\n.cm__person-meta {\n  font-size: 0.71rem;\n  color: var(--admin-muted);\n  margin: 0.1rem 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm__person-action { position: relative; flex-shrink: 0; }\n.cm__move-btn {\n  font-size: 0.72rem !important;\n  padding: 0.25rem 0.5rem !important;\n  gap: 0.2rem;\n}\n\n/* ── Move dropdown ── */\n.cm__move-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 120;\n  min-width: 190px;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n  padding: 0.35rem;\n}\n.cm__move-menu-title {\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  margin: 0.2rem 0.5rem 0.35rem;\n}\n.cm__move-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.45rem 0.5rem;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.79rem;\n  color: var(--admin-text);\n  text-align: left;\n  transition: background 0.12s;\n}\n.cm__move-option:hover:not(:disabled) { background: var(--admin-surface); }\n.cm__move-option:disabled { opacity: 0.45; cursor: not-allowed; }\n.cm__move-option-count { font-size: 0.7rem; color: var(--admin-muted); flex-shrink: 0; }\n.cm__move-option-count--full { color: var(--admin-red); }\n.cm__move-option--unassign {\n  color: var(--admin-red);\n  border-top: 1px solid var(--admin-border);\n  margin-top: 0.25rem;\n  padding-top: 0.5rem;\n  border-radius: 0 0 6px 6px;\n}\n.cm__move-empty {\n  font-size: 0.76rem;\n  color: var(--admin-muted);\n  padding: 0.5rem;\n  margin: 0;\n  text-align: center;\n}\n\n/* ── Unassigned pool ── */\n.cm__unassigned {\n  background: rgba(217, 119, 6, 0.05);\n  border: 1px solid rgba(217, 119, 6, 0.28);\n  border-radius: 10px;\n  padding: 1rem;\n}\n.cm__unassigned-head { margin-bottom: 0.5rem; }\n.cm__unassigned-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #b45309;\n  margin: 0;\n}\n.cm__unassigned-icon { font-size: 1rem; flex-shrink: 0; }\n.cm__unassigned-sub {\n  font-size: 0.77rem;\n  color: var(--admin-muted);\n  margin: 0.25rem 0 0;\n  line-height: 1.5;\n}\n\n/* ── Modal fields ── */\n.cm__field { display: flex; flex-direction: column; gap: 0.3rem; margin-bottom: 0.85rem; }\n.cm__field label { font-size: 0.78rem; font-weight: 700; color: var(--admin-text); }\n.cm__optional { font-weight: 400; color: var(--admin-muted); }\n.cm__field-hint { font-size: 0.72rem; color: var(--admin-muted); margin: 0.1rem 0 0; line-height: 1.45; }\n\n.cm__warn {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  font-size: 0.76rem;\n  color: #b45309;\n  background: rgba(217, 119, 6, 0.08);\n  border: 1px solid rgba(217, 119, 6, 0.25);\n  border-radius: 7px;\n  padding: 0.6rem 0.7rem;\n  margin-bottom: 0.85rem;\n  line-height: 1.5;\n}\n.cm__warn svg { flex-shrink: 0; margin-top: 0.1rem; }\n\n.cm__error {\n  font-size: 0.79rem;\n  font-weight: 600;\n  color: var(--admin-red);\n  margin: 0 0 0.75rem;\n}\n\n.cm__modal-actions { display: flex; gap: 0.5rem; justify-content: flex-end; }\n\n/* ── Responsive ── */\n@media (max-width: 767px) {\n  .cm__head { flex-direction: column; }\n  .cm__head-actions { width: 100%; }\n  .cm__head-actions .a-btn { flex: 1; justify-content: center; }\n  .cm__grid { grid-template-columns: 1fr; }\n  .cm__summary-item { min-width: 0; }\n  .cm__move-menu { right: auto; left: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
